export function equalsIgnoringCase(string1: string, string2: string) {
  return (
    string1.localeCompare(string2, undefined, { sensitivity: 'base' }) === 0
  );
}

export function removePunctuation(text: string) {
  // remove periods, commas, exclamation marks, question marks
  return text.replace(/[.,;!?]/g, '');
}

export const extractTitleFromContent = (
  contentHtml: string,
  maxWords: number = 5,
): string => {
  if (!contentHtml) return '';

  const parser = new DOMParser();
  const doc = parser.parseFromString(contentHtml, 'text/html');

  // First try to get title from H1 or H2 tags
  const h1 = doc.querySelector('h1')?.textContent?.trim();
  const h2 = doc.querySelector('h2')?.textContent?.trim();

  let titleText = h1 || h2;

  // If no heading found, extract from the first paragraph or body text
  if (!titleText) {
    const firstParagraph = doc.querySelector('p')?.textContent?.trim();
    const bodyText = doc.body?.textContent?.trim();
    titleText = firstParagraph || bodyText || '';
  }

  if (!titleText) return '';

  // Clean up the text and extract first few words
  const words = titleText
    .replace(/\s+/g, ' ') // Replace multiple spaces with single space
    .trim()
    .split(' ')
    .slice(0, maxWords)
    .join(' ');

  // Remove trailing punctuation if present
  return words.replace(/[.,;!?]+$/, '');
};
